import { LOG } from '../actions/log';

const initialState = {
  all: {},
  log: {},
  loading: false,
  fetchSuccess: false
};

const reducer = (state = initialState, action) => {
  
  switch (action.type) {
    case LOG.FETCH_ALL: {
      return { ...state, loading: true, fetchSuccess: true };
    }
    case LOG.FETCH_ALL_FAILED: {
      return { ...state, loading: false, fetchSuccess: false};
    }
    case LOG.SET_ALL: {
      const all = action.payload.data;
      return { ...state, all, loading: false, fetchSuccess: true };
    }
    default: {
      return state;
    }
  }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/reducers/log.js